import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';
import { InputPanel } from 'STORE/InputPanelsStore/InputPanel/InputPanel';

interface ICancelVoiceButtonPresenter {
  inputPanel: InputPanel | null;
  onClick(): void;
}

export const useCancelVoiceButtonPresenter = (): ICancelVoiceButtonPresenter => {
  const presenter = useLocalStore<ICancelVoiceButtonPresenter>(() => ({
    get inputPanel(): InputPanel | null {
      return Entities.InputPanelsStore.activeInputPanel;
    },

    onClick(): void {
      if (!presenter.inputPanel) {
        return;
      }

      presenter.inputPanel.voice.reset();
    },
  }));

  return presenter;
};
